export const MIAW_ENABLED_DIVISIONS = [
  '/dc/',
  '/md/',
  '/va/',
  '/tx/',
  '/nc/',
  '/sc/',
  '/az/',
  '/ca/',
  '/co/',
  '/ut/',
  '/wa/',
  '/fl/',
]